import type { App } from 'vue';

import { UserManagerSymbol } from './config';
import { userManager, createUserManager } from './oidc';

const install = (app: App) => {
  app.provide(UserManagerSymbol, { userManager, createUserManager });
};

export * from './oidc';
export * from './config';
export default { install };
